import types from './types';

export function selectSegment(id) {
  return {
    type: types.SELECT_SEGMENT,
    payload: {
      id,
    },
  };
}

export function deselectSegment(id) {
  return {
    type: types.DESELECT_SEGMENT,
    payload: {
      id,
    },
  };
}

export function setCreatedRouteId(id) {
  return {
    type: types.SET_CREATED_ROUTE_ID,
    payload: {
      id,
    },
  };
}

export function clearCreateRoute() {
  return {
    type: types.CLEAR_CREATE_ROUTE,
  };
}



// WEBPACK FOOTER //
// ./src/state/ducks/routeCreation/actions.js